// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/SegoeUIBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/SegoeUI.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: 'segoefont', sans-serif !important;
  background-color: #f5f5f5 !important;
}
@font-face {
  font-family: 'segoefont';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});

}
@font-face {
  font-family: 'segoefont';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});

}
/* @font-face {
  font-family: 'segoefont';
  src: url('fonts/SegoeUIBoldItalic.ttf');

}
@font-face {
  font-family: 'segoefont';
  src: url('fonts/SegoeUIItalic.ttf');
} */

.mainWrapper {
  background-color: #f5f5f5;
}
.mainWrapper.topbar {
  background-color: #fff;
  padding-top: 10px;
  padding-bottom: 10px;
}
.App {
  text-align: center;
}
.form-check-input:checked {
  background-color: #49c740 !important;
  border-color: #49c740 !important;
}
.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.dialogOuter .MuiDialog-container .MuiDialog-paperScrollPaper {
  width: 100%;
  max-width: 75%;
}

.dialogOuter .users .checkBoxSection {
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.dialogOuter .users .checkBoxSection p {
  margin: 0 0 0 8px;
}

.dialogOuter .users .checkBoxSection input[type="checkbox"] {
  cursor: pointer;
}

header {
  display: none !important;
}

.tox-statusbar {
  display: none !important;
}

span.aliaseName {
  margin-left: 0;
  font-size: 14px;
  word-break: break-all;
  cursor: pointer;
  position: relative;
  display: block;
}
.aliaseName .nameInner {
  position: absolute;
  padding: 5px;
  border-radius: 3px;
  background-color: #333;
  color: #fff;
  left: 130px;
  top: -3px;
  min-width: 150px;
  max-width: 250px;
  display: none;
  /* text-align: center; */
  font-size: 14px;
  z-index: 11;
}
.aliaseName .nameInner p {
  margin: 0;
  font-weight: 600;
  margin-top: 10px;
}
.aliaseName .nameInner p span {
  font-weight: 500;
}
.aliaseName .nameInner p:first-child {
  margin-top: 0;
}
span.aliaseName:hover .nameInner {
  display: block;
}
.aliaseName .nameInner::after {
  position: absolute;
  content: " ";
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-right: 10px solid #333;
  border-bottom: 5px solid transparent;
  top: 10px;
  left: -10px;
}



.submit-btn {
  margin: 10px;
  padding: 15px 30px;
  text-align: center;
  text-transform: uppercase;
  transition: 0.5s;
  background-size: 200% auto;
  color: white;
  border-radius: 10px;
  display: block;
  border: 0px;
  font-weight: 700;
  box-shadow: 0px 0px 14px -7px #195bf0;
  background-image: linear-gradient(45deg, #2fa7ff 0%, #1947f0 51%, #2fb2ff 100%);
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.submit-btn:hover {
  background-position: right center;
  /* change the direction of the change here */
  color: #fff;
  text-decoration: none;
}

.submit-btn:active {
  transform: scale(0.95);
}



/* .border {
  border: 1px solid #dee2e6;
} */


.border {
  border: none;
  border-radius: 3px;
  /* box-shadow: 0 2px 24px rgba(0, 0, 0, .1); */
}




.tox-tinymce {
  /* border: 2px solid #bbb7b7 !important; */
  border-radius: 3px!important;
  box-shadow: 0 2px 24px rgba(0, 0, 0, .1)!important;
}
.default-signature {
  margin-top: 30px;
}
.default-signature h4 {
  font-size: 18px;
  color: #333;
  font-weight: 600;
}
.default-signature p {
  font-size: 16px;
  margin: 10px 0;
}
.newComponentOuter {
  width: 100%;
  max-width: 100%;
  height: 100%;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
  z-index: 1111;
  display: none;
  align-items: center;
  justify-content: center;
}
.newComponentOuter .newComponentInner {
  width: 72%;
  background-color: #fff;
  padding: 20px;
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 12px;
}
.newComponentOuter .newComponentInner .closeBtn {
  background-color: transparent;
  border: 0;
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  opacity: 0.7;
}
.newComponentOuter .header {
  font-size: 25px;
  font-weight: 600;
}
.mainWrapper {
  padding-left: 0;
}
.mainWrapper .searchBar .MuiFormControl-root {
  margin: 0;
}
.mainWrapper .main-header h3 {
  margin-bottom: 0;
  font-style: normal;
  font-weight: 600;
}
.mainWrapper table thead tr th {
  background-color: #f5f5f5 !important;
  font-weight: 600;
  color: #818181 !important;
  font-size: 16px;
  font-family: 'segoefont', sans-serif !important;
  white-space: nowrap;
}
.mainWrapper table tbody tr .userName {
  font-weight: 600;
}
.mainWrapper nav ul li button.Mui-selected, .mainWrapper nav ul li button:hover {
  background-color: #fff !important;
  color: #8f8f8f;
  border: 1px solid #dee2e6;
  width: 35px;
  height: 35px;
  padding: 0;
}
.mainWrapper .MuiTableContainer-root::-webkit-scrollbar {
  height: 7px;
}

.mainWrapper .MuiTableContainer-root::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
 
.mainWrapper .MuiTableContainer-root::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  border-radius: 10px;
}
.mainWrapper .addBtn button {
  background-color: #49c740;
  border: 1px solid #49c740;
  padding: 8px 20px;
  border-radius: 25px;
  color: #fff;
}
.mainWrapper table tbody tr td .commonAction {
  font-size: 15px;
  padding: 0;
  width: 35px;
  height: 35px;
  max-width: 40px;
  /* background: red; */
  min-width: auto;
}
.mainWrapper table tbody tr td .commonAction.editButton {
  background-color: rgba(69, 173, 0, 0.1);
  color: #49c740;
  border: 1px solid #49c740;
}
.mainWrapper table tbody tr td .commonAction.editButton:hover {
  background-color: #49c740;
  color: #fff;
}
.mainWrapper table tbody tr td .commonAction.sendAsButton {
  background-color: rgba(69, 173, 0, 0.1);
  color: #49c740;
  border: 1px solid #49c740;
}
.mainWrapper table tbody tr td .commonAction.sendAsButton:hover {
  background-color: #49c740;
  color: #fff;
}
.mainWrapper table tbody tr td .commonAction.deleteButton {
  background-color: rgba(255, 0, 0, 0.2);
  border: 1px solid rgba(255, 0, 0, 0.5);
  color: #f00;
  margin-left: 10px;
}
.mainWrapper table tbody tr td .commonAction.deleteButton:hover {
  background-color: #f00;
  color: #fff;
}
.mainWrapper .commonForm {
  padding: 20px 0;
}
.mainWrapper .commonForm label {
  font-weight: 500;
  margin-bottom: 8px;
}
/* .mainWrapper .commonForm h3 {} */
.mainWrapper .commonForm .form-control {
  height: 45px;
  margin-bottom: 10px;
}
.mainWrapper .commonForm .btn-submit {
  background-color: #49c740;
  border: 1px solid #49c740;
  padding: 7px 30px;
  border-radius: 25px;
  color: #fff;
  margin-top: 10px;
  font-weight: 500;
}
/* .newComponentOuter::before {
  position: fixed;
  content: " ";
  background-color: rgba(0, 0, 0, .2);
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: -1;
} */
.newComponentOuter .template-section .checkBoxSection, .newComponentOuter .users .checkBoxSection {
  display: flex;
}
.newComponentOuter .template-section .checkBoxSection .form-check-input:checked, .newComponentOuter .users .checkBoxSection .form-check-input:checked {
  background-color: #49c740;
  border-color: #49c740;
}
.newComponentOuter .template-section h4, .newComponentOuter .userOuter h4, .newComponentOuter .newComponentInner .preview h4 {
  font-size: 18px;
}
.newComponentOuter .templateListContainer .btn-submit {
  background-color: #49c740;
  border: 1px solid #49c740;
  padding: 7px 20px;
  border-radius: 25px;
  color: #fff;
  margin-top: 10px;
  font-weight: 500;
  font-size: 16px;
}
.newComponentOuter .templateListContainer .btn-preview {
  border-radius: 25px;
}
.previewOuter .MuiIconButton-root {
  padding: 0;
}
.sigNameSection {
  display: flex;
  gap: 10px;
  margin-bottom: 30px;
}
.sigNameSection p {
  font-weight: 500;
  width: 250px;
}
.preview  .previewInner {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 5px;
}
.btn-preview {
  background-color: #c9c9c9;
  font-weight: 600;
  margin-top: 20px;
}
.newComponentOuter .newComponentInner .template-section, .newComponentOuter .newComponentInner .userOuter .users {
  height: 310px;
  overflow: auto;
}
.newComponentOuter .newComponentInner .template-section::-webkit-scrollbar, .newComponentOuter .newComponentInner .userOuter .users::-webkit-scrollbar {
  width: 5px;
}
 
.newComponentOuter .newComponentInner .template-section::-webkit-scrollbar-track, .newComponentOuter .newComponentInner .userOuter .users::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
 
.newComponentOuter .newComponentInner .template-section::-webkit-scrollbar-thumb, .newComponentOuter .newComponentInner .userOuter .users::-webkit-scrollbar-thumb {
  background-color: darkgrey;
}
.domainUsers .users .checkBoxSection .checkBoxSectionInner, .domainUsers .template-section-inner .checkBoxSection {
  display: flex;
  align-items: center;
}
.domainUsers .userOuter .users, .domainUsers .template-section .template-section-inner {
  height: 380px;
  overflow: auto;
}
.domainUsers .userOuter .users .form-check .form-check-input:checked, .domainUsers .template-section .template-section-inner .form-check .form-check-input:checked {
  background-color: #49c740;
  border-color: #49c740;
}
.domainUsers .template-section .template-section-inner {
  margin-top: 45px;
}
.innerCheckbox {
  padding: 0 27px;
  margin-bottom: 12px;
}
.innerCheckbox .checkBoxSection {
  display: flex;
}
.domainUsers .userOuter .users::-webkit-scrollbar, .domainUsers .template-section .template-section-inner::-webkit-scrollbar {
  width: 5px;
}

.domainUsers .userOuter .users::-webkit-scrollbar-track, .domainUsers .template-section .template-section-inner::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
 
.domainUsers .userOuter .users::-webkit-scrollbar-thumb, .domainUsers .template-section .template-section-inner::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  border-radius: 10px;
}
.domainUsers .templateListContainer .btn-submit {
  background-color: #49c740;
  border: 1px solid #49c740;
  padding: 7px 20px;
  border-radius: 25px;
  color: #fff;
  margin-top: 10px;
  font-weight: 500;
  font-size: 16px;
}
.userOuter .selectAllWrapper {
  display: flex;
  margin-bottom: 10px;
}
.userOuter .selectAllWrapper input {
  /* width: auto; */
  /* margin-right: 10px; */
}
.userOuter .alias {
  margin: 6px 0 10px 0;
  background: #f5f5f5;
  padding: 6px 10px;
  font-weight: 500;
  border-radius: 3px;
}
.commonListing table {
  border-collapse: separate;
  border-spacing: 0px 8px;
  border: none;
}
.commonListing .MuiPaper-elevation {
  box-shadow: none;
  background-color: transparent;
}
.commonListing table tbody tr {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}
.commonListing table tbody tr td, .commonListing table tbody tr th {
  border: 0;
  font-weight: 500;
  vertical-align: middle;
  padding: 20px 15px;
  color: #333;
  font-size: 14px;
  background-color: #fff;
  font-family: 'segoefont', sans-serif !important;
}
.commonListing table tbody tr td {
  font-weight: 600;
}
.commonListing table tbody tr td .status {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  background-color: #fff;
  margin-right: 5px;
}
.commonListing table tbody tr td .status.statusComplete {
  border: 3px solid #008000;
}
.commonListing table tbody tr td .status.statusFailed {
  border: 3px solid #f00;
}
.commonListing table tbody tr td .status.statusIncomplete {
  border: 3px solid #d98c27;
}
.topbar .searchBar .MuiOutlinedInput-root {
  margin-left: auto;
  height: 40px;
  width: 250px;
}
.topbar .searchBar .Mui-focused fieldset {
  border-color: rgba(0, 0, 0, 0.23);
}
.topbar .buttonSection {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 5px;
}
.MuiPagination-ul li button {
  border-radius: 50%;
  background-color: transparent;
  border: 0;
  color: #8f8f8f;
  font-weight: 700;
  padding: 9px 16px;
}
.topbar .buttonSection p {
  margin: 0;
  color: #49c740;
  font-weight: 600;
}
.topbar .buttonSection span {
  color: #333;
  font-weight: 500;
}
.topbar .buttonSection button {
  background-color: #49c740;
  color: #fff;
}
.commonListing table tr td .dropdown .dropdown-toggle {
  background-color: transparent;
  color: #333;
  border: 0;
  padding: 0;
  font-size: 20px;
}
.commonListing table tr td .dropdown .editButton, .commonListing table tr td .dropdown .deleteButton {
  width: 100%;
  background-color: transparent !important;
  border: none !important;
  color: #333 !important;
  width: auto;
  max-width: none;
  height: auto;
  padding: 3px 10px;
  text-transform: capitalize;
  font-weight: 600;
  margin: 0 !important;
}
.commonListing table tr td .dropdown .editButton i, .commonListing table tr td .dropdown .deleteButton i {
  margin-right: 5px;
}
.commonListing table tr td .dropdown .dropdown-toggle::after {
  display: none;
}
.commonListing table tr td .dropdown .dropdown-menu {
  padding: 0;
}
.commonListing table tr td .dropdown .dropdown-menu li {
  border-bottom: 1px solid #ddd;
}
.commonListing table tr td .dropdown .dropdown-menu li:last-child {
  border: 0;
}
.userListing.commonListing table thead tr th:nth-child(6) span, .userListing.commonListing table thead tr th:nth-child(7) span, .userListing.commonListing table thead tr th:nth-child(8) span {
  display: block;
  width: 150px;
}
.MuiCircularProgress-colorPrimary .MuiCircularProgress-svg circle {
  color: #49c740;
}
.pointer {
  cursor: pointer;
}
.previewSectionInner {
  overflow-x: auto;
}
.pagination {
  display: flex;
  align-items: center;
  gap: 10px;
}
.pagination select {
  border: 1px solid #ddd;
  padding: 5px 10px;
  border-radius: 5px;
  outline: none;
  background-color: #fff;
}
.pagination p {
  margin: 0;
  font-weight: 600;
  color: #999;
}
.signatureView {
  position: absolute;
  transform: translate(-50%, -50%);
  background-color: #fff;
  top: 50%;
  left: 50%;
  width: 750px;
  padding: 10px;
}
.signatureView h3 {
  font-weight: 600;
}
.modal-header {
  margin-bottom: 20px;
}
.modal-header .btn-close {
  background-color: transparent;
  border: 0;
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  opacity: 0.7;
  background: transparent;
  box-shadow: none;
}
.signatureView .commonListing {
  height: 400px;
  overflow: auto;
}
.signatureView .commonListing .table tr th {
  font-weight: 600;
}
.signatureView .commonListing .table tr td {
  font-weight: 500;
}

.app-shell {
  min-height: 100vh;
  background-color: #f5f5f5;
  overflow: hidden;
}

.app-shell.with-sidebar {
  display: flex;
}

.app-shell__content {
  flex: 1 1;
  padding: 24px;
  min-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.app-shell.with-sidebar .app-shell__content {
  margin-left: 240px;
  transition: margin-left 0.3s ease;
}

@media (max-width: 1024px) {
  .app-shell.with-sidebar .app-shell__content {
    margin-left: 220px;
  }
}

@media (max-width: 768px) {
  .app-shell.with-sidebar {
    display: block;
  }

  .app-shell.with-sidebar .app-shell__content {
    margin-left: 0;
    padding: 16px;
  }
}

.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.login-card {
  width: 100%;
  max-width: 360px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  padding: 32px;
}

.login-title {
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 24px;
  color: #333333;
}

.login-error {
  background-color: rgba(220, 53, 69, 0.12);
  color: #dc3545;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 16px;
  font-size: 14px;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.login-label {
  font-weight: 600;
  color: #333333;
  font-size: 14px;
}

.login-input {
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  padding: 12px 14px;
  font-size: 14px;
  transition: border-color 0.2s ease;
}

.login-input:focus {
  outline: none;
  border-color: #49c740;
  box-shadow: 0 0 0 3px rgba(73, 199, 64, 0.15);
}

.login-submit {
  margin-top: 8px;
  background-color: #49c740;
  border: 1px solid #49c740;
  border-radius: 6px;
  color: #ffffff;
  padding: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.login-submit:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.login-submit:not(:disabled):hover {
  background-color: #3fa734;
  transform: translateY(-1px);
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,oCAAoC;AACtC;AACA;EACE,wBAAwB;EACxB,4CAAiC;;AAEnC;AACA;EACE,wBAAwB;EACxB,4CAA6B;;AAE/B;AACA;;;;;;;;GAQG;;AAEH;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,wBAAwB;EACxB,eAAe;EACf,WAAW;AACb;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,6BAA6B;EAC7B,oCAAoC;EACpC,SAAS;EACT,WAAW;AACb;;;;AAIA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,+EAA+E;EAC/E,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,4CAA4C;EAC5C,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;;;AAIA;;GAEG;;;AAGH;EACE,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;AAChD;;;;;AAKA;EACE,0CAA0C;EAC1C,4BAA4B;EAC5B,kDAAkD;AACpD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,MAAM;EACN,OAAO;EACP,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,+CAA+C;EAC/C,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;AACb;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,uCAAuC;EACvC,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,uCAAuC;EACvC,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA,mCAAmC;AACnC;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;;;;;;;;GASG;AACH;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,+CAA+C;AACjD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;AACA;EACE,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,SAAS;EACT,UAAU;EACV,eAAe;AACjB;AACA;EACE,WAAW;EACX,wCAAwC;EACxC,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B","sourcesContent":["body {\n  font-family: 'segoefont', sans-serif !important;\n  background-color: #f5f5f5 !important;\n}\n@font-face {\n  font-family: 'segoefont';\n  src: url('fonts/SegoeUIBold.ttf');\n\n}\n@font-face {\n  font-family: 'segoefont';\n  src: url('fonts/SegoeUI.ttf');\n\n}\n/* @font-face {\n  font-family: 'segoefont';\n  src: url('fonts/SegoeUIBoldItalic.ttf');\n\n}\n@font-face {\n  font-family: 'segoefont';\n  src: url('fonts/SegoeUIItalic.ttf');\n} */\n\n.mainWrapper {\n  background-color: #f5f5f5;\n}\n.mainWrapper.topbar {\n  background-color: #fff;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n.App {\n  text-align: center;\n}\n.form-check-input:checked {\n  background-color: #49c740 !important;\n  border-color: #49c740 !important;\n}\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.dialogOuter .MuiDialog-container .MuiDialog-paperScrollPaper {\n  width: 100%;\n  max-width: 75%;\n}\n\n.dialogOuter .users .checkBoxSection {\n  margin: 0 0 8px 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.dialogOuter .users .checkBoxSection p {\n  margin: 0 0 0 8px;\n}\n\n.dialogOuter .users .checkBoxSection input[type=\"checkbox\"] {\n  cursor: pointer;\n}\n\nheader {\n  display: none !important;\n}\n\n.tox-statusbar {\n  display: none !important;\n}\n\nspan.aliaseName {\n  margin-left: 0;\n  font-size: 14px;\n  word-break: break-all;\n  cursor: pointer;\n  position: relative;\n  display: block;\n}\n.aliaseName .nameInner {\n  position: absolute;\n  padding: 5px;\n  border-radius: 3px;\n  background-color: #333;\n  color: #fff;\n  left: 130px;\n  top: -3px;\n  min-width: 150px;\n  max-width: 250px;\n  display: none;\n  /* text-align: center; */\n  font-size: 14px;\n  z-index: 11;\n}\n.aliaseName .nameInner p {\n  margin: 0;\n  font-weight: 600;\n  margin-top: 10px;\n}\n.aliaseName .nameInner p span {\n  font-weight: 500;\n}\n.aliaseName .nameInner p:first-child {\n  margin-top: 0;\n}\nspan.aliaseName:hover .nameInner {\n  display: block;\n}\n.aliaseName .nameInner::after {\n  position: absolute;\n  content: \" \";\n  width: 0;\n  height: 0;\n  border-top: 5px solid transparent;\n  border-right: 10px solid #333;\n  border-bottom: 5px solid transparent;\n  top: 10px;\n  left: -10px;\n}\n\n\n\n.submit-btn {\n  margin: 10px;\n  padding: 15px 30px;\n  text-align: center;\n  text-transform: uppercase;\n  transition: 0.5s;\n  background-size: 200% auto;\n  color: white;\n  border-radius: 10px;\n  display: block;\n  border: 0px;\n  font-weight: 700;\n  box-shadow: 0px 0px 14px -7px #195bf0;\n  background-image: linear-gradient(45deg, #2fa7ff 0%, #1947f0 51%, #2fb2ff 100%);\n  cursor: pointer;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n}\n\n.submit-btn:hover {\n  background-position: right center;\n  /* change the direction of the change here */\n  color: #fff;\n  text-decoration: none;\n}\n\n.submit-btn:active {\n  transform: scale(0.95);\n}\n\n\n\n/* .border {\n  border: 1px solid #dee2e6;\n} */\n\n\n.border {\n  border: none;\n  border-radius: 3px;\n  /* box-shadow: 0 2px 24px rgba(0, 0, 0, .1); */\n}\n\n\n\n\n.tox-tinymce {\n  /* border: 2px solid #bbb7b7 !important; */\n  border-radius: 3px!important;\n  box-shadow: 0 2px 24px rgba(0, 0, 0, .1)!important;\n}\n.default-signature {\n  margin-top: 30px;\n}\n.default-signature h4 {\n  font-size: 18px;\n  color: #333;\n  font-weight: 600;\n}\n.default-signature p {\n  font-size: 16px;\n  margin: 10px 0;\n}\n.newComponentOuter {\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  position: fixed;\n  background-color: rgba(0, 0, 0, 0.2);\n  top: 0;\n  left: 0;\n  z-index: 1111;\n  display: none;\n  align-items: center;\n  justify-content: center;\n}\n.newComponentOuter .newComponentInner {\n  width: 72%;\n  background-color: #fff;\n  padding: 20px;\n  position: relative;\n  max-height: 90vh;\n  overflow-y: auto;\n  border-radius: 12px;\n}\n.newComponentOuter .newComponentInner .closeBtn {\n  background-color: transparent;\n  border: 0;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  opacity: 0.7;\n}\n.newComponentOuter .header {\n  font-size: 25px;\n  font-weight: 600;\n}\n.mainWrapper {\n  padding-left: 0;\n}\n.mainWrapper .searchBar .MuiFormControl-root {\n  margin: 0;\n}\n.mainWrapper .main-header h3 {\n  margin-bottom: 0;\n  font-style: normal;\n  font-weight: 600;\n}\n.mainWrapper table thead tr th {\n  background-color: #f5f5f5 !important;\n  font-weight: 600;\n  color: #818181 !important;\n  font-size: 16px;\n  font-family: 'segoefont', sans-serif !important;\n  white-space: nowrap;\n}\n.mainWrapper table tbody tr .userName {\n  font-weight: 600;\n}\n.mainWrapper nav ul li button.Mui-selected, .mainWrapper nav ul li button:hover {\n  background-color: #fff !important;\n  color: #8f8f8f;\n  border: 1px solid #dee2e6;\n  width: 35px;\n  height: 35px;\n  padding: 0;\n}\n.mainWrapper .MuiTableContainer-root::-webkit-scrollbar {\n  height: 7px;\n}\n\n.mainWrapper .MuiTableContainer-root::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n}\n \n.mainWrapper .MuiTableContainer-root::-webkit-scrollbar-thumb {\n  background-color: darkgrey;\n  border-radius: 10px;\n}\n.mainWrapper .addBtn button {\n  background-color: #49c740;\n  border: 1px solid #49c740;\n  padding: 8px 20px;\n  border-radius: 25px;\n  color: #fff;\n}\n.mainWrapper table tbody tr td .commonAction {\n  font-size: 15px;\n  padding: 0;\n  width: 35px;\n  height: 35px;\n  max-width: 40px;\n  /* background: red; */\n  min-width: auto;\n}\n.mainWrapper table tbody tr td .commonAction.editButton {\n  background-color: rgba(69, 173, 0, 0.1);\n  color: #49c740;\n  border: 1px solid #49c740;\n}\n.mainWrapper table tbody tr td .commonAction.editButton:hover {\n  background-color: #49c740;\n  color: #fff;\n}\n.mainWrapper table tbody tr td .commonAction.sendAsButton {\n  background-color: rgba(69, 173, 0, 0.1);\n  color: #49c740;\n  border: 1px solid #49c740;\n}\n.mainWrapper table tbody tr td .commonAction.sendAsButton:hover {\n  background-color: #49c740;\n  color: #fff;\n}\n.mainWrapper table tbody tr td .commonAction.deleteButton {\n  background-color: rgba(255, 0, 0, 0.2);\n  border: 1px solid rgba(255, 0, 0, 0.5);\n  color: #f00;\n  margin-left: 10px;\n}\n.mainWrapper table tbody tr td .commonAction.deleteButton:hover {\n  background-color: #f00;\n  color: #fff;\n}\n.mainWrapper .commonForm {\n  padding: 20px 0;\n}\n.mainWrapper .commonForm label {\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n/* .mainWrapper .commonForm h3 {} */\n.mainWrapper .commonForm .form-control {\n  height: 45px;\n  margin-bottom: 10px;\n}\n.mainWrapper .commonForm .btn-submit {\n  background-color: #49c740;\n  border: 1px solid #49c740;\n  padding: 7px 30px;\n  border-radius: 25px;\n  color: #fff;\n  margin-top: 10px;\n  font-weight: 500;\n}\n/* .newComponentOuter::before {\n  position: fixed;\n  content: \" \";\n  background-color: rgba(0, 0, 0, .2);\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  z-index: -1;\n} */\n.newComponentOuter .template-section .checkBoxSection, .newComponentOuter .users .checkBoxSection {\n  display: flex;\n}\n.newComponentOuter .template-section .checkBoxSection .form-check-input:checked, .newComponentOuter .users .checkBoxSection .form-check-input:checked {\n  background-color: #49c740;\n  border-color: #49c740;\n}\n.newComponentOuter .template-section h4, .newComponentOuter .userOuter h4, .newComponentOuter .newComponentInner .preview h4 {\n  font-size: 18px;\n}\n.newComponentOuter .templateListContainer .btn-submit {\n  background-color: #49c740;\n  border: 1px solid #49c740;\n  padding: 7px 20px;\n  border-radius: 25px;\n  color: #fff;\n  margin-top: 10px;\n  font-weight: 500;\n  font-size: 16px;\n}\n.newComponentOuter .templateListContainer .btn-preview {\n  border-radius: 25px;\n}\n.previewOuter .MuiIconButton-root {\n  padding: 0;\n}\n.sigNameSection {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 30px;\n}\n.sigNameSection p {\n  font-weight: 500;\n  width: 250px;\n}\n.preview  .previewInner {\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  padding: 5px;\n}\n.btn-preview {\n  background-color: #c9c9c9;\n  font-weight: 600;\n  margin-top: 20px;\n}\n.newComponentOuter .newComponentInner .template-section, .newComponentOuter .newComponentInner .userOuter .users {\n  height: 310px;\n  overflow: auto;\n}\n.newComponentOuter .newComponentInner .template-section::-webkit-scrollbar, .newComponentOuter .newComponentInner .userOuter .users::-webkit-scrollbar {\n  width: 5px;\n}\n \n.newComponentOuter .newComponentInner .template-section::-webkit-scrollbar-track, .newComponentOuter .newComponentInner .userOuter .users::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n \n.newComponentOuter .newComponentInner .template-section::-webkit-scrollbar-thumb, .newComponentOuter .newComponentInner .userOuter .users::-webkit-scrollbar-thumb {\n  background-color: darkgrey;\n}\n.domainUsers .users .checkBoxSection .checkBoxSectionInner, .domainUsers .template-section-inner .checkBoxSection {\n  display: flex;\n  align-items: center;\n}\n.domainUsers .userOuter .users, .domainUsers .template-section .template-section-inner {\n  height: 380px;\n  overflow: auto;\n}\n.domainUsers .userOuter .users .form-check .form-check-input:checked, .domainUsers .template-section .template-section-inner .form-check .form-check-input:checked {\n  background-color: #49c740;\n  border-color: #49c740;\n}\n.domainUsers .template-section .template-section-inner {\n  margin-top: 45px;\n}\n.innerCheckbox {\n  padding: 0 27px;\n  margin-bottom: 12px;\n}\n.innerCheckbox .checkBoxSection {\n  display: flex;\n}\n.domainUsers .userOuter .users::-webkit-scrollbar, .domainUsers .template-section .template-section-inner::-webkit-scrollbar {\n  width: 5px;\n}\n\n.domainUsers .userOuter .users::-webkit-scrollbar-track, .domainUsers .template-section .template-section-inner::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n}\n \n.domainUsers .userOuter .users::-webkit-scrollbar-thumb, .domainUsers .template-section .template-section-inner::-webkit-scrollbar-thumb {\n  background-color: darkgrey;\n  border-radius: 10px;\n}\n.domainUsers .templateListContainer .btn-submit {\n  background-color: #49c740;\n  border: 1px solid #49c740;\n  padding: 7px 20px;\n  border-radius: 25px;\n  color: #fff;\n  margin-top: 10px;\n  font-weight: 500;\n  font-size: 16px;\n}\n.userOuter .selectAllWrapper {\n  display: flex;\n  margin-bottom: 10px;\n}\n.userOuter .selectAllWrapper input {\n  /* width: auto; */\n  /* margin-right: 10px; */\n}\n.userOuter .alias {\n  margin: 6px 0 10px 0;\n  background: #f5f5f5;\n  padding: 6px 10px;\n  font-weight: 500;\n  border-radius: 3px;\n}\n.commonListing table {\n  border-collapse: separate;\n  border-spacing: 0px 8px;\n  border: none;\n}\n.commonListing .MuiPaper-elevation {\n  box-shadow: none;\n  background-color: transparent;\n}\n.commonListing table tbody tr {\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);\n}\n.commonListing table tbody tr td, .commonListing table tbody tr th {\n  border: 0;\n  font-weight: 500;\n  vertical-align: middle;\n  padding: 20px 15px;\n  color: #333;\n  font-size: 14px;\n  background-color: #fff;\n  font-family: 'segoefont', sans-serif !important;\n}\n.commonListing table tbody tr td {\n  font-weight: 600;\n}\n.commonListing table tbody tr td .status {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-block;\n  background-color: #fff;\n  margin-right: 5px;\n}\n.commonListing table tbody tr td .status.statusComplete {\n  border: 3px solid #008000;\n}\n.commonListing table tbody tr td .status.statusFailed {\n  border: 3px solid #f00;\n}\n.commonListing table tbody tr td .status.statusIncomplete {\n  border: 3px solid #d98c27;\n}\n.topbar .searchBar .MuiOutlinedInput-root {\n  margin-left: auto;\n  height: 40px;\n  width: 250px;\n}\n.topbar .searchBar .Mui-focused fieldset {\n  border-color: rgba(0, 0, 0, 0.23);\n}\n.topbar .buttonSection {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  margin-top: 5px;\n}\n.MuiPagination-ul li button {\n  border-radius: 50%;\n  background-color: transparent;\n  border: 0;\n  color: #8f8f8f;\n  font-weight: 700;\n  padding: 9px 16px;\n}\n.topbar .buttonSection p {\n  margin: 0;\n  color: #49c740;\n  font-weight: 600;\n}\n.topbar .buttonSection span {\n  color: #333;\n  font-weight: 500;\n}\n.topbar .buttonSection button {\n  background-color: #49c740;\n  color: #fff;\n}\n.commonListing table tr td .dropdown .dropdown-toggle {\n  background-color: transparent;\n  color: #333;\n  border: 0;\n  padding: 0;\n  font-size: 20px;\n}\n.commonListing table tr td .dropdown .editButton, .commonListing table tr td .dropdown .deleteButton {\n  width: 100%;\n  background-color: transparent !important;\n  border: none !important;\n  color: #333 !important;\n  width: auto;\n  max-width: none;\n  height: auto;\n  padding: 3px 10px;\n  text-transform: capitalize;\n  font-weight: 600;\n  margin: 0 !important;\n}\n.commonListing table tr td .dropdown .editButton i, .commonListing table tr td .dropdown .deleteButton i {\n  margin-right: 5px;\n}\n.commonListing table tr td .dropdown .dropdown-toggle::after {\n  display: none;\n}\n.commonListing table tr td .dropdown .dropdown-menu {\n  padding: 0;\n}\n.commonListing table tr td .dropdown .dropdown-menu li {\n  border-bottom: 1px solid #ddd;\n}\n.commonListing table tr td .dropdown .dropdown-menu li:last-child {\n  border: 0;\n}\n.userListing.commonListing table thead tr th:nth-child(6) span, .userListing.commonListing table thead tr th:nth-child(7) span, .userListing.commonListing table thead tr th:nth-child(8) span {\n  display: block;\n  width: 150px;\n}\n.MuiCircularProgress-colorPrimary .MuiCircularProgress-svg circle {\n  color: #49c740;\n}\n.pointer {\n  cursor: pointer;\n}\n.previewSectionInner {\n  overflow-x: auto;\n}\n.pagination {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.pagination select {\n  border: 1px solid #ddd;\n  padding: 5px 10px;\n  border-radius: 5px;\n  outline: none;\n  background-color: #fff;\n}\n.pagination p {\n  margin: 0;\n  font-weight: 600;\n  color: #999;\n}\n.signatureView {\n  position: absolute;\n  transform: translate(-50%, -50%);\n  background-color: #fff;\n  top: 50%;\n  left: 50%;\n  width: 750px;\n  padding: 10px;\n}\n.signatureView h3 {\n  font-weight: 600;\n}\n.modal-header {\n  margin-bottom: 20px;\n}\n.modal-header .btn-close {\n  background-color: transparent;\n  border: 0;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  opacity: 0.7;\n  background: transparent;\n  box-shadow: none;\n}\n.signatureView .commonListing {\n  height: 400px;\n  overflow: auto;\n}\n.signatureView .commonListing .table tr th {\n  font-weight: 600;\n}\n.signatureView .commonListing .table tr td {\n  font-weight: 500;\n}\n\n.app-shell {\n  min-height: 100vh;\n  background-color: #f5f5f5;\n  overflow: hidden;\n}\n\n.app-shell.with-sidebar {\n  display: flex;\n}\n\n.app-shell__content {\n  flex: 1;\n  padding: 24px;\n  min-height: 100vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.app-shell.with-sidebar .app-shell__content {\n  margin-left: 240px;\n  transition: margin-left 0.3s ease;\n}\n\n@media (max-width: 1024px) {\n  .app-shell.with-sidebar .app-shell__content {\n    margin-left: 220px;\n  }\n}\n\n@media (max-width: 768px) {\n  .app-shell.with-sidebar {\n    display: block;\n  }\n\n  .app-shell.with-sidebar .app-shell__content {\n    margin-left: 0;\n    padding: 16px;\n  }\n}\n\n.login-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n\n.login-card {\n  width: 100%;\n  max-width: 360px;\n  background-color: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n  padding: 32px;\n}\n\n.login-title {\n  font-size: 24px;\n  font-weight: 600;\n  text-align: center;\n  margin-bottom: 24px;\n  color: #333333;\n}\n\n.login-error {\n  background-color: rgba(220, 53, 69, 0.12);\n  color: #dc3545;\n  border-radius: 6px;\n  padding: 12px;\n  margin-bottom: 16px;\n  font-size: 14px;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.login-label {\n  font-weight: 600;\n  color: #333333;\n  font-size: 14px;\n}\n\n.login-input {\n  border: 1px solid #d0d5dd;\n  border-radius: 6px;\n  padding: 12px 14px;\n  font-size: 14px;\n  transition: border-color 0.2s ease;\n}\n\n.login-input:focus {\n  outline: none;\n  border-color: #49c740;\n  box-shadow: 0 0 0 3px rgba(73, 199, 64, 0.15);\n}\n\n.login-submit {\n  margin-top: 8px;\n  background-color: #49c740;\n  border: 1px solid #49c740;\n  border-radius: 6px;\n  color: #ffffff;\n  padding: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.2s ease;\n}\n\n.login-submit:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.login-submit:not(:disabled):hover {\n  background-color: #3fa734;\n  transform: translateY(-1px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
